import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Flame, Leaf, Sprout, Droplet } from 'lucide-react';
const ingredients = [{
  icon: Flame,
  title: 'Ginger + Black Pepper',
  desc: 'Create deep, penetrating warmth that supports blood flow'
}, {
  icon: Leaf,
  title: 'Eucalyptus',
  desc: 'Calms pain signals without dulling sensation'
}, {
  icon: Sprout,
  title: 'Rosemary',
  desc: 'Supports circulation and tissue recovery'
}, {
  icon: Droplet,
  title: 'Fast-absorbing botanical oils',
  desc: 'No residue. No film. No mess.'
}];
export function BodyReliefMechanismSection() {
  return <section className="py-8 sm:py-12 bg-white" data-id="element-227">
      <div className="max-w-6xl mx-auto px-4" data-id="element-228">
        <div className="text-center mb-8 sm:mb-10 max-w-3xl mx-auto" data-id="element-229">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-light text-charcoal mb-3 tracking-tight" data-id="element-230">
            How It Works (What Actually Matters)
          </h2>
          <p className="text-sm sm:text-base text-charcoal-light font-light" data-id="element-231">
            Most creams sit on the surface.{' '}
            <span className="text-ginger font-normal" data-id="element-232">
              GINEXT works beneath it.
            </span>
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6" data-id="element-233">
          {ingredients.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-bone p-5 sm:p-6 rounded-xl border border-bone-dark hover:border-ginger/30 transition-colors group" data-id="element-234">
              <div className="w-10 h-10 bg-white rounded-full flex items-center justify-center mb-4 shadow-sm group-hover:shadow-warm transition-all" data-id="element-235">
                <item.icon className="w-5 h-5 text-ginger" data-id="element-236" />
              </div>
              <h3 className="text-base font-normal text-charcoal mb-2" data-id="element-237">
                {item.title}
              </h3>
              <p className="text-charcoal-light text-xs leading-relaxed font-light" data-id="element-238">
                {item.desc}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.6
      }} className="mt-8 sm:mt-10 text-center" data-id="element-239">
          <p className="text-lg sm:text-xl font-light italic text-charcoal" data-id="element-240">
            The result? Warmth spreads. Tension releases. Movement feels easier
            again.
          </p>
        </motion.div>

        {/* Botanical Image - Mobile Only */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.7,
        duration: 0.6
      }} className="mt-8 md:hidden" data-id="element-241">
          <img src="https://cdn.magicpatterns.com/uploads/97sqaUrdBqUciwRvsyNBPa/u8896349413_High-end_editorial_still_life_of_natural_botanica_49b5ba3a-5db6-456d-b96b-050e1d7f556a_0_(1).png" alt="Natural botanical ingredients" className="w-full h-auto rounded-xl shadow-lg" loading="lazy" data-id="element-242" />
        </motion.div>
      </div>
    </section>;
}